import { getLength } from 'ol/sphere';
import { get, put } from '../utility/http';
import { InspectionAnalisysHistoryJob, 
  InspectionAnalisysPointData, 
  InspectionAnalysisData, 
  InspectionAnalysisFlights, 
  InspectionAnalysisGeneric,
  InspectionAnalysisGeometries, 
  InspectionAnalysisGeometry } 
  from '../model/inspectionAnalysisInterface';

export async function fetchData(ctx: string) {
  /*try {
    //const response = await get(
    // `/tracks/ctx/${ctx}/listLinked`,
    // true
    //);
    return {
      'data': {
        'layers': [{ 
          id: 234,
          'geometries': [
            {
              'label': 'route',
              'geometry': {
                'type': 'LineString',
                'crs': {
                  'type': 'name',
                  'properties': {
                    'name': 'EPSG:4326'
                  }
                },
                'coordinates': [
                  [
                    12.498161217737113,
                    42.49566804365795,
                    0
                  ],
                  [
                    12.498274097966544,
                    42.495497276131374,
                    0
                  ],
                  [
                    12.498352245817687,
                    42.495404656455946,
                    0
                  ],
                  [
                    12.498447759857973,
                    42.49538150153709,
                    0
                  ],
                  [
                    12.498496964060543,
                    42.49537571280737,
                    0
                  ],
                  [
                    12.498595372465687,
                    42.49534676915881,
                    0
                  ],
                  [
                    12.4986011611954,
                    42.495204945280804,
                    0
                  ],
                  [
                    12.498566428817115,
                    42.495103642510806,
                    0
                  ],
                  [
                    12.498543273898258,
                    42.4950226002948,
                    0
                  ],
                  [
                    12.498583795006258,
                    42.49497050172737,
                    0
                  ],
                  [
                    12.498650365397973,
                    42.494956029903086,
                    0
                  ],
                  [
                    12.498702463965401,
                    42.49494155807881,
                    0
                  ],
                  [
                    12.498803766735401,
                    42.49491550879509,
                    0
                  ],
                  [
                    12.498852970937973,
                    42.494877882051945,
                    0
                  ],
                  [
                    12.498829816019116,
                    42.49483157221423,
                    0
                  ],
                  [
                    12.498812449829973,
                    42.49478815674137,
                    0
                  ],
                  [
                    12.498797978005687,
                    42.49472737507937,
                    0
                  ],
                  [
                    12.498884808951402,
                    42.49475342436309,
                    0
                  ],
                  [
                    12.498960062437687,
                    42.49472737507937,
                    0
                  ],
                  [
                    12.49903821028883,
                    42.49472448071452,
                    0
                  ],
                  [
                    12.499055576477973,
                    42.49467527651195,
                    0
                  ],
                  [
                    12.499145301788545,
                    42.4946579103228,
                    0
                  ],
                  [
                    12.499197400355973,
                    42.49464054413366,
                    0
                  ],
                  [
                    12.49927265384226,
                    42.49462607230937,
                    0
                  ],
                  [
                    12.499452104463403,
                    42.494576868106805,
                    0
                  ],
                  [
                    12.49949551993626,
                    42.49464054413366,
                    0
                  ],
                  [
                    12.498823038287714,
                    42.49519349037932, 
                    0
                  ],
                  [
                    12.49954472413883,
                    42.49477657928195,
                    0
                  ],
                  [
                    12.499559195963117,
                    42.4948402553088,
                    0
                  ],
                  [
                    12.499622871989974,
                    42.494938663713945,
                    0
                  ],
                  [
                    12.499648921273689,
                    42.495008128470516,
                    0
                  ],
                  [
                    12.499706808570831,
                    42.49504575521366,
                    0
                  ],
                  [
                    12.49970970293569,
                    42.495164424172806,
                    0
                  ],
                  [
                    12.49972996348969,
                    42.49526283257795,
                    0
                  ],
                  [
                    12.499756012773403,
                    42.49538150153709,
                    0
                  ],
                  [
                    12.499773378962546,
                    42.49547412121252,
                    0
                  ],
                  [
                    12.499787850786833,
                    42.495549374698804,
                    0
                  ]
                ]
              }
            }
          ] 
        }],
        'flights': [
          {
            'id': '1',
            'label': 'V1', 
            'geometries': [
              {
                'label': 'route',
                'geometry': {
                  'type': 'LineString',
                  'crs': {
                    'type': 'name',
                    'properties': {
                      'name': 'EPSG:4326'
                    }
                  },
                  'coordinates': [
                    [
                      12.4978526,
                      42.4943619,
                      250.822998046875,
                      1
                    ],
                    [
                      12.4980092,
                      42.4943731,
                      252.35350036621094,
                      1
                    ],
                    [
                      12.4979598,
                      42.4956129,
                      270.0946044921875,
                      1
                    ],
                    [
                      12.4981171,
                      42.4956077,
                      265.976806640625,
                      1
                    ],
                    [
                      12.4981658,
                      42.4943843,
                      254.48480224609375,
                      1
                    ],
                    [
                      12.4983225,
                      42.4943954,
                      254.37330627441406,
                      1
                    ],
                    [
                      12.4982743,
                      42.4956025,
                      268.60740661621094,
                      1
                    ],
                    [
                      12.4984316,
                      42.4955973,
                      271.7153015136719,
                      1
                    ],
                    [
                      12.4984791,
                      42.4944066,
                      253.564697265625,
                      1
                    ],
                    [
                      12.4986358,
                      42.4944178,
                      251.8966064453125,
                      1
                    ],
                    [
                      12.4985889,
                      42.4955922,
                      273.70399475097656,
                      1
                    ],
                    [
                      12.4987462,
                      42.495587,
                      272.00830078125,
                      1
                    ],
                    [
                      12.4987924,
                      42.494429,
                      251.04429626464844,
                      1
                    ],
                    [
                      12.498949,
                      42.4944402,
                      251.1436004638672,
                      1
                    ],
                    [
                      12.4989035,
                      42.4955818,
                      269.66859436035156,
                      1
                    ],
                    [
                      12.4990608,
                      42.4955766,
                      262.91709899902344,
                      1
                    ],
                    [
                      12.4991021,
                      42.4945419,
                      251.26319885253906,
                      1
                    ],
                    [
                      12.4992543,
                      42.4946637,
                      250.64129638671875,
                      1
                    ],
                    [
                      12.4992181,
                      42.4955714,
                      258.7064971923828,
                      1
                    ],
                    [
                      12.4993768,
                      42.4955308,
                      254.30889892578125,
                      1
                    ],
                    [
                      12.4994065,
                      42.4947855,
                      252.5959930419922,
                      1
                    ],
                    [
                      12.4995587,
                      42.4949073,
                      252.41290283203125,
                      1
                    ],
                    [
                      12.4995437,
                      42.4952835,
                      251.70640563964844,
                      1
                    ],
                    [
                      12.499711,
                      42.4950291,
                      252.1085968017578,
                      1
                    ]
                  ]
                }
              }
            ] 
          },
          {
            'id': '2',
            'label': 'V2', 
            'geometries': [
              {
                'label': 'route',
                'geometry': {
                  'type': 'LineString',
                  'crs': {
                    'type': 'name',
                    'properties': {
                      'name': 'EPSG:4326'
                    }
                  },
                  'coordinates': [
                    [
                      12.497852519615515,
                      42.49482376898039,
                      252.1085968017578,
                      1
                    ],
                    [
                      12.498253051131027,
                      42.49491619933012,
                      252.1085968017578,
                      1
                    ],
                    [
                      12.498422506772203,
                      42.495301325787345,
                      252.1085968017578,
                      1
                    ],
                    [
                      12.498823038287714,
                      42.49519349037932,
                      252.1085968017578,
                      1
                    ],
                    [
                      12.498083595489849,
                      42.4945310728729,
                      252.1085968017578,
                      1
                    ],
                    [
                      12.498776823112847,
                      42.49468512345579,
                      252.1085968017578,
                      1
                    ]
                  ]
                }
              }
            ]
            
            
          }
        ],
        'defects': [
          {
            'id': 1,
            'code': '0012',
            'label': 'Fondazioni',
            'time': '07/03/2024 15:32',
            'images': ['0012.jpg'],
            'name': 'Danni alla base delle fondazioni',
            'desc': 'Controllare a livello del pilone ' + 
              'e della base per verificare che non vi siano influenze esterne',
            'geometries': [
              {
                'label': 'point',
                'geometry': {
                  'type': 'Point',
                  'crs': {
                    'type': 'name',
                    'properties': {
                      'name': 'EPSG:4326'
                    }
                  },
                  'coordinates': [
                    12.498576538287714,
                    42.49525349037932,
                    0,
                    1
                  ]
                }
              }
            ]
          },
          {
            'id': 2,
            'code': '1113',
            'label': 'Pilone',
            'time': '07/03/2024 15:22',
            'name': 'Danni alla struttura del pilone',
            'desc': 'Deformazione azione esterna ' + 
              'Diagonali o aste angolari',
            'geometries': [
              {
                'label': 'point',
                'geometry': {
                  'type': 'Point',
                  'crs': {
                    'type': 'name',
                    'properties': {
                      'name': 'EPSG:4326'
                    }
                  },
                  'coordinates': [
                    12.4995945,
                    42.4948855,
                    0,
                    1
                  ]
                }
              }
            ]
          }
        ]
      }
    };
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }*/
  
  try 
  {
    const response: any = await get(
      `/defects/ctx/${ctx}`,
      true,
      {}
    );
    //console.log('response API Inspector');
    //console.log(response);

    const flights: InspectionAnalysisFlights[] = [];

    for await (const element of response.data) 
    {
      let jobId = '';
      let jobLabel = '';
      let runId = '';

      if(element.tracks && element.tracks.length > 0)
        runId = element.tracks[0];

      const temp = await getTypeFromrunId(runId, ctx);
      let type = '';
      if(temp?.length > 0)
      {
        jobId = temp[0].jobId;
        jobLabel = temp[0].jobLabel;
        const types = temp[0].types;
  
        if(types.length > 0)
          type = types[0];
      }
      //console.log(runId);
      //console.log(type);

      /*
      'id': '1',
            'label': 'V1', 
            'geometries': [
              {
                'label': 'route',
                'geometry': {
                  'type': 'LineString',
                  'crs': {
                    'type': 'name',
                    'properties': {
                      'name': 'EPSG:4326'
                    }
                  },
                  'coordinates': [
                    [
                      12.4978526,
                      42.4943619,
                      250.822998046875,
                      1
                    ],
      */

      const tempJob = await fetchjobHistoryDetail(runId, type);
      const jobHistory: InspectionAnalisysHistoryJob[] = tempJob?.data??[];
      
      const geomTemp: InspectionAnalysisGeometry = {
        type: 'LineString',
        crs: {
          type: 'name',
          properties: {
            name: ''
          }
        },
        coordinates: []
      };

      const geomGenTemp: InspectionAnalysisGeometries = {
        label: 'route',
        geometry: geomTemp
      };

      jobHistory.forEach((fh) => {
        const tempCoo: number[] = [fh.geom.coordinates[0], 
          fh.geom.coordinates[1], fh.geom.coordinates[2]];

        geomTemp.coordinates.push(tempCoo);
        geomTemp.crs.properties.name = fh.geom.crs.properties.name;
      });

      const flight: InspectionAnalysisFlights = {
        id: jobId,
        label: jobLabel,
        geometries: geomGenTemp
      };
      //console.log('flight');
      //console.log(flight);
      flights.push(flight);
      
      //console.log('tempJob');
      //console.log(tempJob);
      //console.log('response');
      //console.log(response);
    }

    const defects: InspectionAnalysisData[] = response.data;
    
    const layers = [{ 
      id: 234,
      'geometries': [
        {
          'label': 'route',
          'geometry': {
            'type': 'LineString',
            'crs': {
              'type': 'name',
              'properties': {
                'name': 'EPSG:4326'
              }
            },
            'coordinates': [
              [
                12.498161217737113,
                42.49566804365795,
                0
              ],
              [
                12.498274097966544,
                42.495497276131374,
                0
              ],
              [
                12.498352245817687,
                42.495404656455946,
                0
              ],
              [
                12.498447759857973,
                42.49538150153709,
                0
              ],
              [
                12.498496964060543,
                42.49537571280737,
                0
              ],
              [
                12.498595372465687,
                42.49534676915881,
                0
              ],
              [
                12.4986011611954,
                42.495204945280804,
                0
              ],
              [
                12.498566428817115,
                42.495103642510806,
                0
              ],
              [
                12.498543273898258,
                42.4950226002948,
                0
              ],
              [
                12.498583795006258,
                42.49497050172737,
                0
              ],
              [
                12.498650365397973,
                42.494956029903086,
                0
              ],
              [
                12.498702463965401,
                42.49494155807881,
                0
              ],
              [
                12.498803766735401,
                42.49491550879509,
                0
              ],
              [
                12.498852970937973,
                42.494877882051945,
                0
              ],
              [
                12.498829816019116,
                42.49483157221423,
                0
              ],
              [
                12.498812449829973,
                42.49478815674137,
                0
              ],
              [
                12.498797978005687,
                42.49472737507937,
                0
              ],
              [
                12.498884808951402,
                42.49475342436309,
                0
              ],
              [
                12.498960062437687,
                42.49472737507937,
                0
              ],
              [
                12.49903821028883,
                42.49472448071452,
                0
              ],
              [
                12.499055576477973,
                42.49467527651195,
                0
              ],
              [
                12.499145301788545,
                42.4946579103228,
                0
              ],
              [
                12.499197400355973,
                42.49464054413366,
                0
              ],
              [
                12.49927265384226,
                42.49462607230937,
                0
              ],
              [
                12.499452104463403,
                42.494576868106805,
                0
              ],
              [
                12.49949551993626,
                42.49464054413366,
                0
              ],
              [
                12.498823038287714,
                42.49519349037932, 
                0
              ],
              [
                12.49954472413883,
                42.49477657928195,
                0
              ],
              [
                12.499559195963117,
                42.4948402553088,
                0
              ],
              [
                12.499622871989974,
                42.494938663713945,
                0
              ],
              [
                12.499648921273689,
                42.495008128470516,
                0
              ],
              [
                12.499706808570831,
                42.49504575521366,
                0
              ],
              [
                12.49970970293569,
                42.495164424172806,
                0
              ],
              [
                12.49972996348969,
                42.49526283257795,
                0
              ],
              [
                12.499756012773403,
                42.49538150153709,
                0
              ],
              [
                12.499773378962546,
                42.49547412121252,
                0
              ],
              [
                12.499787850786833,
                42.495549374698804,
                0
              ]
            ]
          }
        }
      ] 
    }];

    const inspGeneric: InspectionAnalysisGeneric = {layers, flights, defects};
    
    //console.log('inspGeneric');
    //console.log(inspGeneric);

    return inspGeneric;

    //return (response as any).data;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}

export async function fetchjobHistoryDetail(runId: any, types: any) {
  try {
    const response = await get(
      `/tracks/history/runId/${runId}/types/${types}`,
      true
    );
    return response as any;
  } catch (e: any) {
    console.log('errore history:');
    console.log(e);
    return null;
  }
}

export async function getTypeFromrunId(runId: string, ctx: string) 
{
  try 
  {
    const response = await get(
      `/tracks/summary-no-uavid?ctx=${ctx}&runId=${runId}`,
      true,
      {}
    );
    //console.log('response API getTypeFromrunId');
    //console.log(response);

    const data = (response as any).data;

    return data;
  }
  catch (e: any) 
  {
    return Promise.reject(e.response ? e.response : e);
  }
}